/**
 * @desc 查询库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuGetQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/getStockSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
